import { CacheExchangeOpts } from "@urql/exchange-graphcache";
import {
  playlistMutationUpdates,
  playlistOptimistic,
} from "../playlist/graphql/PlaylistCacheUpdates";

/** graphcache configuration shared by the app and the tests (without storage and schema). */
export const graphCacheConfig: Pick<
  CacheExchangeOpts,
  "keys" | "optimistic" | "updates"
> = {
  keys: {
    //manual casting (as string) to satisfy the type checker --> better idea? let me know.
    CrewInformationUB: (data) => data.identifier as string,
    OrganizationCrewUB: (data) => data.identifier as string,
    // Embedded in the playlist: item mutations always write the whole list, and item ids are only unique per playlist
    PlaylistItemUB: () => null,
    SongnumberUB: () => null,
    DerivedImageUB: () => null,
    PlaylistUB: (data) => data.id as string,
    SongnumberWithSongUB: () => null,
    SongUB: (data) => data.id as string,
  },
  // Mutations only wait in the offline queue if they have an optimistic result.
  optimistic: {
    ...playlistOptimistic,
  },
  updates: {
    Mutation: {
      deleteSongs: (_result, _, cache) => {
        // Invalidate the cache entries related to the deleted songs. This triggers a refetch of the relevant queries.
        cache.invalidate("SongUB");
      },
      ...playlistMutationUpdates,
    },
  },
};
